import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
// import "../Profile.css";


import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,
    Trash2,
    Radio,
    CircleCheck,
    FolderTree,
    RectangleEllipsis,
    RouteOff,
    Route,
    ToggleLeft,
    SquareCheck,
    Minus,
    ArrowUp10,
    ArrowLeftRight,
    ArrowBigDownDash,
    ArrowBigUpDash,
    ArrowBigLeftDash,
    ArrowBigRightDash} from 'lucide-react';

import LoadingButton from "../../../Loading/LoadingButton";
import ImageWithFallback from "../../../UI/ImageFallBack";
import Toggle from "../../../UI/Toggle";
import OptionValuesAddMore from "./OptionValuesAddMore";
import UploaderAllCM from "../Uploader/UploaderAllCM";
import { getAllFilesBys3Key } from "../../../../store/actions/CreateContent/FolderAPI/LessonAPI";

 const CreateQueOptionPopUp= ({objectNew,currentOption,setItemTitle,setItemImg,setOptionSingleBack,setOptionRangeBack,setIsCorrectBack,setTextBoxValueBack,setIsAllowPartialMarksBack,setPartialMarksBack,updateDisplayType,updateIsSingleRange,updateOptionBoxAlign,sendBackData,sendBackObject,closeOptionPopUp})=>{
    // const {category} = useParams();
   

    const App = useSelector((state)=>state?.app?.app);
     
    const dispatch = useDispatch();  
  
    const currentToken = useSelector((state)=>state?.user?.user?.token);
    const user_email = useSelector((state)=>state?.user?.user?.user_email
   );
   const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
   const appId = useSelector((state)=>state?.app?.app?.ID);
   const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
        
   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [isOptionCorrect, setIsOptionCorrect] = useState(false);
    
    const [snackbarColor, setSnackbarColor] = useState("#958FDA");
    const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
    const showSnackbar = () => {
     setSnackbarVisible(true);
   };
   
    const hideSnackbar = () => {
     setSnackbarVisible(false);
   };

       const [loader , setLoader] =useState({status:false});
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
          {
            
            dispatch({type: "CURSOR",payload:true  });
        
            dispatch({type: "CURSORTEXT",payload:CursorText})
            dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
            dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
          }
           
          const handleMouseLeave = () => {
            
            dispatch({type: "CURSOR",payload:false})
        
            dispatch({type: "CURSORTEXT",payload:""})
        
            dispatch({type: "CURSORTEXTBG",payload:""})
            dispatch({type: "CURSORTEXTCOLOR",payload:""})
          
        
        } 
    
        
        const [optionText, setOptionText] = useState(currentOption?.optionText);

        const [optionImg, setOptionImg] = useState(currentOption?.optionImg);
        const [partialMarks, setPartialMarks] = useState(currentOption?.partialMarks?currentOption?.partialMarks:0);
        const [displayType, setDisplayType] = useState(currentOption?.displayType);
        const [dropdownValues, setDropdownValues] = useState(currentOption?.dropdownValues.length?JSON.parse(currentOption?.dropdownValues):[]);
        const [isAllowPartialMarks, setIsAllowPartialMarks] = useState(currentOption?.isAllowPartialMarks);
        const [isCorrect, setIsCorrect] = useState(currentOption?.isCorrect);
        const [textBoxValue, setTextBoxValue] = useState(currentOption?.textBoxValue);
        const [choiceType, setChoiceType] = useState(currentOption?.questionType=="MCQ"?"radio":currentOption?.questionType=="MSQ"?"checkbox":"radio");
      const [questionType, setQuestionType] = useState(currentOption?.questionType);
       const [isSingleRange, setIsSingleRange] = useState(currentOption?.isSingleRange);
        const [optionSingle, setOptionSingle] = useState(currentOption?.optionSingle);
        const [optionRange, setOptionRange] = useState(JSON.parse(currentOption?.optionRange));
        const [dragOrder, setDragOrder] = useState(currentOption?.dragOrder);
       const [openUploaderPopUp ,setOpenUploaderPopUp] = useState(false)
         const [isOptionBoxAlign, setOptionBoxAlign] = useState(currentOption?.optionBoxAlign); 
     const [loadStatus, setLoadStatus] = useState(true); 
    const [currentFileObject,setCurrentFileObject] = useState({}); 
    const [currentFile,setCurrentFile] = useState(""); 
      const [currentFileType, setCurrentFileType] = useState({});
       useEffect(()=>{
        fireFetchFileLinkByS3Key();
       },[currentFileObject?.file_s3_key,optionImg])
       
        {/* let newOption= {
      ID: generateTimestamp(),
      questionType: "",
      optionText: "",
    optionImg: "",
    partialMarks: "",
    displayType: "",
    dropdownValues: "",
    isAllowPartialMarks: false,
    isCorrect: false,
    textBoxValue: ""
}; */}
                        
       const [itemArr, setItemArr] = useState([]);
       
         const [selectedItemIndex, setSelectedItemIndex] = useState(null); 
           let dropdownValuesArr=[{ no:1, id: generateTimestamp()
                 ,optionTitle:"A" ,choiceCorrect:false},{ no:2, id: generateTimestamp()+2
                 ,optionTitle:"B",choiceCorrect:false,allowPartialMarks:false,partialMarksChoice:0,choiceBoxAlign:"left", },];
            let newChoice={ no:itemArr?.length+1, id: generateTimestamp()+itemArr?.length+1
                 ,optionTitle:"",optionTitle2:"",choiceCorrect:false,allowPartialMarks:true,partialMarksChoice:1,choiceBoxAlign:"left" }
            useEffect(() => {
              //  highlights?.length !== 0?setItemArr(highlights):
                setItemArr(dropdownValues?.length?dropdownValues:dropdownValuesArr)
                   setDropdownValues(dropdownValues?.length?dropdownValues:dropdownValuesArr)
          //    alert(dropdownValues?.length)
          //  console.log(dropdownValues)
              
            }, []);
           
        
    function generateTimestamp() {
           return Math.floor(Date.now() / 1000);
         }
   
         const removeItem = (id) => {
           const filteredItems = itemArr.filter(item => item.id !== id);
           setItemArr(filteredItems);
            setDropdownValues(filteredItems)
          //  sendBackData(filteredItems)
         };
         const updateItemOptionTitle = (id, OptionTitle) => {
           const updatedItems = itemArr.map(item =>
             item.id === id ? { ...item, optionTitle :OptionTitle } : item
           
           ); 
           
           setItemArr(updatedItems);
              setDropdownValues(updatedItems)
          //  sendBackData(updatedItems)
         }; 

          const updateDraggableImageStatus = (id, DraggableImage) => {
           
           const updatedItems = itemArr.map(item =>
             item.id === id ? { ...item, draggableImage :DraggableImage } : item
           
           ); 
           
        setItemArr(updatedItems);
             
              setDropdownValues(updatedItems);

          //  sendBackData(updatedItems)
         };  const updateOptionImageStatus = (id, OptionImage) => {
           const updatedItems = itemArr.map(item =>
             item.id === id ? { ...item, optionImage :OptionImage } : item
           
           ); 
           
           setItemArr(updatedItems);
             
              setDropdownValues(updatedItems);

          //  sendBackData(updatedItems)
         }; 



  const updateDraggableImage = (id, DraggableImageKey) => {
           
           const updatedItems = itemArr.map(item =>
             item.id === id ? { ...item, draggableImageKey :DraggableImageKey } : item
           
           ); 
           
        setItemArr(updatedItems);
             
              setDropdownValues(updatedItems);
  
          //  sendBackData(updatedItems)
         };  const updateOptionImage = (id, OptionImageKey) => {
           const updatedItems = itemArr.map(item =>
             item.id === id ? { ...item, optionImageKey :OptionImageKey } : item
           
           ); 
           
           setItemArr(updatedItems);
             
              setDropdownValues(updatedItems);

          //  sendBackData(updatedItems)
         }; 


             const updateItemOptionTitle2 = (id, OptionTitle2) => {
           const updatedItems = itemArr.map(item =>
             item.id === id ? { ...item, optionTitle2 :OptionTitle2 } : item
           
           ); 
           
           setItemArr(updatedItems);
              setDropdownValues(updatedItems)
          //  sendBackData(updatedItems)
         }; 
         
         const updateChoiceCorrect = (id, choiceCorrect) => {
           let updatedItems ;
         if(currentOption?.questionType=="MCQ"){
      updatedItems = itemArr.map(item =>
             item.id === id ? { ...item, choiceCorrect :choiceCorrect } : { ...item, choiceCorrect :false }
           
           ); 
         }else{
  updatedItems = itemArr.map(item =>
             item.id === id ? { ...item, choiceCorrect :choiceCorrect } : item
           
           ); 
         } 
        
           setItemArr(updatedItems);
              setDropdownValues(updatedItems)
          //  sendBackData(updatedItems)
         }; 
         
          const updateAllowPartialMarks = (id, allowPartialMarks) => {
           const updatedItems = itemArr.map(item =>
             item.id === id ? { ...item, allowPartialMarks :allowPartialMarks } : item
           
           ); 
           
           setItemArr(updatedItems);
              setDropdownValues(updatedItems)
          //  sendBackData(updatedItems)
         };  const updatePartialMarksChoice = (id, partialMarksChoice) => {
           const updatedItems = itemArr.map(item =>
             item.id === id ? { ...item, partialMarksChoice :partialMarksChoice } : item
           
           ); 
           
           setItemArr(updatedItems);
              setDropdownValues(updatedItems)
          //  sendBackData(updatedItems)
         };
          
         const updateChoiceCorrectAll = ( nullValue) => {
           const updatedItems = itemArr.map(item =>
             ({ ...item, choiceCorrect :nullValue,allowPartialMarks:nullValue })
           
           ); 
           setLoadStatus(false);setTimeout(()=>{setLoadStatus(true);},0);
           setItemArr(updatedItems);
              setDropdownValues(updatedItems)
          //  sendBackData(updatedItems)
         }; 
       const flattenedData = itemArr!=[]?Object.values(itemArr):[];
   
     
   const [draggedIndex, setDraggedIndex] = useState('');
   const [hoveredDropZone, setHoveredDropZone] = useState(null); // Track hovered drop zone
   
   const handleDragStart = (e, index) => {
     
     e.dataTransfer.effectAllowed = 'move';
     e.dataTransfer.setData("dragIndex", index);
     
   };
   
   const handleDrop = (e, dropIndex) => {
     const dragIndex = e.dataTransfer.getData("dragIndex");
     if (dragIndex === dropIndex) return;
   
     const updatedItems = [...itemArr];
     const [draggedItem] = updatedItems.splice(dragIndex, 1);
     updatedItems.splice(dropIndex, 0, draggedItem);
   
     const reorderedItems = updatedItems.map((item, index) => ({
       ...item,
       id: item.id,
     }));
     setItemArr(reorderedItems);
     setDropdownValues(reorderedItems)
     setDraggedIndex('');
     setHoveredDropZone(null); // Reset hovered drop zone
   };
   
   const handleDragOver = (e, index) => {
     e.preventDefault();
      // Set the hovered drop zone
   };
   
   const handleDragEnd = () => {
     setDraggedIndex('');
     setHoveredDropZone(null); // Clear hovered drop zone
   };
   
    
      const fireFetchFileLinkByS3Key=(e)=>{
      
                  
      setLoader({status:true});
        const apiData = dispatch(getAllFilesBys3Key({userEmail:user_email?user_email:null,
        currentToken:currentToken?currentToken:null,appToken:AppToken,appId:appId,fileKey:optionImg,
        editType:"getFileListByS3Key"}));
        /* get response as Promise   */
        apiData.then(response => {
          if(response){
      
            
            if(response){
            setCurrentFile(response?.file?.file)
            setCurrentFileObject(response?.file)
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
      },1000)
         }else{
          setResponseMessage("Something Went Wrong...");
            
          setSnackbarColor("#958FDA");
       
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)
         }
            
         
         if(response?.logout){
         
          setResponseMessage("You are Logged Out!!!");
            
          setSnackbarColor("#958FDA");
       
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)
          setTimeout(()=>{
            dispatch({type:"LOGOUT"});
      
          },3000)
          
        }
      /* resetting Login input Fields */
      
          }else{
            setResponseMessage("Something Went Wrong...");
            
            setSnackbarColor("#958FDA");
         
             
        setLoader({status:false});
        
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
         
           
        },3000)    }
      
        }).catch(error => {
       
          //popup of error Info
          setResponseMessage("Something Went Wrong...");
            
          setSnackbarColor("#958FDA");
       
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)
          console.error(error);
        });
       
        }
         
   
       return <>
       
   
 
 <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{zIndex:99,cursor:"pointer"}} onClick={()=>closeOptionPopUp(false)} className="appDesignPopUpOpacity"> </div>
        <div   className="QueOptionPopUp" style={{borderRadius: '20px',zIndex:"99999999999"}}> 
        <h2 align="center" >  <span className="coloredTextV1" >  {currentOption?.questionType} Option Details</span> </h2>
      
 
<div className="optionPopUpScroll" style={{}}>

    <div className="">
    
  
   <div >
    
<div style={{} }>
<div  className="" >{
<div  className="ikcraft_login-input-card">
 <textarea onMouseEnter={handleMouseEnter} disabled={questionType=="True-False"?true:false}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"18px"}} placeholder={`Add Option  Name`} type="text"
  rows={2} name="optionText" value={optionText} onChange={(e)=>{setOptionText(e.target.value);
  setItemTitle(currentOption?.ID,e.target.value,currentOption?.ID)
  
  }} />
 </div>}
 
<div style={{background:"#ffffff",borderRadius:"15px",paddingBottom:"10px",marginTop:"10px",padding:"10px",}}>
                            
      
                 {questionType=="MCQ"||questionType=="MSQ"||questionType=="NAT"? 
                  <div className="" style={{background:"rgba(144, 202, 249,0.11)",borderRadius:"0px",paddingBottom:"0px",marginTop:"10px",
                    height:"80px"}}> 
             <div >  
                 <div style={{}}> 
                  <div class=""style={{
                       
                        transition: 'transform 3s ease, opacity 3s ease',
                      borderRadius:"25px",padding:"5px"}} >
                                                
                                                <div style={{display:"flex",justifyContent:"space-between"}}>
                                                   <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"10px",
                       paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                       {questionType=="NAT"?"Numerical Answer Type":"Option Display" }</div> 
                                              {questionType=="MCQ"? <label onMouseEnter={
                                                   ()=>handleMouseEnter("#fff","#333","")}
                                    onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}} >
                                                  <div style={{display:"flex",flexDirection:"column"}} >
                                                  
                                                 <div style={{display:"flex",justifyContent:"center"}}>
                                                   <CircleCheck onMouseEnter={handleMouseEnter}
                                                                           onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                            
                                                                           }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                           </div>                     
                                                                                 <div style={{position:"relative",fontSize:"14px"}}>Radio</div>
                                                   </div> 
                                      <input type="radio" title="Set As Years"   checked={displayType=="radio"?"yes":""}
                         className="input-textbox"  value={"radio"}  name="displayType1"  
                         onClick={e=>{setDisplayType("radio");;updateDisplayType(currentOption?.ID,"radio")}}/>
                              <span class={"boxCardBorder-two"}></span> </label> :questionType=="MSQ"? <label onMouseEnter={
                                                   ()=>handleMouseEnter("#fff","#333","")}
                                    onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}} >
                                                  <div style={{display:"flex",flexDirection:"column"}} >
                                                  
                                                 <div style={{display:"flex",justifyContent:"center"}}>
                                                   <SquareCheck onMouseEnter={handleMouseEnter}
                                                                           onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                            
                                                                           }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                           </div>                     
                                                                                 <div style={{position:"relative",fontSize:"14px"}}>Checkbox</div>
                                                   </div> 
                                      <input type="radio" title=""   checked={displayType=="checkbox"?"yes":""}
                         className="input-textbox"  value={"checkbox"}  name="displayType1"  
                         onClick={e=>{setDisplayType("checkbox");;updateDisplayType(currentOption?.ID,"checkbox")}}/>
                              <span class={"boxCardBorder-two"}></span> </label> :""}   
                           { questionType=="MCQ"|| questionType=="MSQ"?   <label onMouseEnter={
                                                   ()=>handleMouseEnter("#fff","#333","")}
                                    onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}} >
                                                  <div style={{display:"flex",flexDirection:"column"}} >
                                                  
                                                 <div style={{display:"flex",justifyContent:"center"}}>
                                                   <FolderTree onMouseEnter={handleMouseEnter}
                                                                           onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                            
                                                                           }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                           </div>                     
                                                                                 <div style={{position:"relative",fontSize:"14px"}}>Dropdown</div>
                                                   </div> 
                                      <input type="radio" title="Set As Years"   checked={displayType=="dropdown"?"yes":""}
                         className="input-textbox"  value={"dropdown"}  name="displayType1"  
                         onClick={e=>{setDisplayType("dropdown");;updateDisplayType(currentOption?.ID,"dropdown")}}/>
                              <span class={"boxCardBorder-two"}></span> </label> :""}
                             {questionType=="MSQ"? <label onMouseEnter={
                                                   ()=>handleMouseEnter("#fff","#333","")}
                                    onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}} >
                                                  <div style={{display:"flex",flexDirection:"column"}} >
                                                  
                                                 <div style={{display:"flex",justifyContent:"center"}}>
                                                   <RectangleEllipsis onMouseEnter={handleMouseEnter}
                                                                           onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                            
                                                                           }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                           </div>                     
                                                                                 <div style={{position:"relative",fontSize:"14px"}}>TextBox</div>
                                                   </div> 
                                      <input type="radio" title="Set As Years"   checked={displayType=="textbox"?"yes":""}
                         className="input-textbox"  value={"textbox"}  name="displayType1"  
                         onClick={e=>{setDisplayType("textbox");;updateDisplayType(currentOption?.ID,"textbox")}}/>
                              <span class={"boxCardBorder-two"}></span> </label> :""}

                              { questionType=="NAT"?   <><label onMouseEnter={
                                                   ()=>handleMouseEnter("#fff","#333","")}
                                    onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}} >
                                                  <div style={{display:"flex",flexDirection:"column"}} >
                                                  
                                                 <div style={{display:"flex",justifyContent:"center"}}>
                                                   <ArrowUp10 onMouseEnter={handleMouseEnter}
                                                                           onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                            
                                                                           }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                           </div>                     
                                                                                 <div style={{position:"relative",fontSize:"14px"}}>Single</div>
                                                   </div> 
                                      <input type="radio" title="Set As Years"   checked={isSingleRange=="false"?"yes":""}
                         className="input-textbox"  value={"false"}  name="isSingleRange1"  
                         onClick={e=>{setIsSingleRange("false");updateIsSingleRange(currentOption?.ID,"false")}}/>
                              <span class={"boxCardBorder-two"}></span> </label><label onMouseEnter={
                                                   ()=>handleMouseEnter("#fff","#333","")}
                                    onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}} >
                                                  <div style={{display:"flex",flexDirection:"column"}} >
                                                  
                                                 <div style={{display:"flex",justifyContent:"center"}}>
                                                   <ArrowLeftRight onMouseEnter={handleMouseEnter}
                                                                           onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                            
                                                                           }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                           </div>                     
                                                                                 <div style={{position:"relative",fontSize:"14px"}}>Range</div>
                                                   </div> 
                                      <input type="radio" title="Set As Years"   checked={isSingleRange=="true"?"yes":""}
                         className="input-textbox"  value={"true"}  name="isSingleRange1"  
                         onClick={e=>{setIsSingleRange("true");;updateIsSingleRange(currentOption?.ID,"true")}}/>
                              <span class={"boxCardBorder-two"}></span> </label> </>:""}
                              </div>  </div></div> </div>
                              
                                                          </div>:""}
      
                       </div>


                       {displayType=="textbox"? <div  style={{background:"#ffffff",borderRadius:"15px",marginTop:"10px",padding:"5px",}}> 

                         <div style={{background:"transparent",border:"0px solid rgba(144, 202, 249,1)",
             
              transition: 'transform 2s ease, opacity 2s ease',display:"flex",justifyContent:"space-around"
            }}><div style={{textAlign:"left"}}><h4>{"Correct Text"} </h4></div>
           <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"14px"}} placeholder={`Correct Option Text`} type="text"
  rows={1} name="optionText" value={textBoxValue} onChange={(e)=>{setTextBoxValue(e.target.value);
  setTextBoxValueBack(currentOption?.ID,e.target.value,currentOption?.ID)
  
  }} />
      </div> 
      
      
      
      </div>:""}
 {(displayType=="dropdown"||displayType=="textbox")?"":<div><div style={{fontSize:"14px",fontWeight:"bold",padding:"10px",marginTop:"15px",
                 paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                  Want To Add Image As Option?</div> 
   <div className="" style={{display:"flex",justifyContent:"space-around",background:"rgba(144, 202, 249,0.2)",borderRadius:"10px",marginTop:"10px",marginLeft:"10px",marginRight:"10px",marginBottom:"10px",paddingLeft:"10px",paddingTop:"5px",paddingBottom:"5px",paddingBottom:"5px"}}> 
      <div>{currentFile?<ImageWithFallback src={currentFile} widthOuter={"70px"} fireOpenEdit ={()=>{setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}  iconSize={28} setOpenFullImg={()=>{setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}/>:""}
 </div> 
 
 
 
  <div>
  <button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}   className=" CoursesPreviewTopBtn" style={{marginTop:"20px",}}  type="submit"
 > Upload Image </button>
 </div>
 </div>
 
              </div> }


              {(displayType=="dropdown"||displayType=="textbox")?"":(questionType=="NAT"||questionType=="Drag Matching")?"":<div>
 <div  style={{background:"#ffffff",borderRadius:"15px",marginTop:"10px",padding:"5px",}}> 

                         <div style={{background:"transparent",border:"0px solid rgba(144, 202, 249,1)",
             
              transition: 'transform 2s ease, opacity 2s ease',display:"flex",justifyContent:"space-around"
            }}><div style={{textAlign:"left"}}><h4>{"Is This Option Correct?"} </h4></div>
            <Toggle state={isCorrect=="false"?false:isCorrect=="true"?true:false} toggleState={(state)=>{setIsCorrect(JSON.stringify(state)); setIsCorrectBack(currentOption?.ID,JSON.stringify(state));}} />
      </div> 
      
      
      
      </div>
     
              
              </div> }
{questionType=="NAT"&&isSingleRange=="false"? <div style={{padding:"15px",}}>
  <div style={{background:"transparent",border:"0px solid rgba(144, 202, 249,1)",
             
              transition: 'transform 2s ease, opacity 2s ease',display:"flex",justifyContent:"space-around"
            }}><div style={{textAlign:"left"}}><h4>{"Add Correct Answer"} </h4></div><input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"14px"}} placeholder={`Correct Number Value`} type="number"
  name="optionText" value={parseFloat(optionSingle)} onChange={(e)=>{setOptionSingle(e.target.value);
  setOptionSingleBack(currentOption?.ID,e.target.value,currentOption?.ID)
  
  }} /></div></div>:questionType=="NAT"&&isSingleRange=="true"? <div style={{padding:"15px",}}>
  <div style={{background:"transparent",border:"0px solid rgba(144, 202, 249,1)",
             
              transition: 'transform 2s ease, opacity 2s ease',display:"flex",justifyContent:"space-around"
            }}><div style={{textAlign:"left"}}><h4>{"Minimum"} </h4></div><input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"14px",width:"60px"}} placeholder={`Min`} type="number"
  name="optionText" value={optionRange?.start} onChange={(e)=>{setOptionRange({...optionRange,start:e.target.value});
  setOptionRangeBack(currentOption?.ID,{...optionRange,start:e.target.value},currentOption?.ID)
  
  }} /><div style={{textAlign:"left"}}><h4>{"Maximum"} </h4></div><input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"14px",width:"60px"}} placeholder={`Max`} type="number"
  name="optionText" value={optionRange?.end} onChange={(e)=>{setOptionRange({...optionRange,end:e.target.value});
  setOptionRangeBack(currentOption?.ID,{...optionRange,end:e.target.value},currentOption?.ID)
  
  }} /></div></div>:""}
    {questionType=="MSQ"&&(displayType=="checkbox"||displayType=="textbox")?<div>
      <div  style={{background:"rgba(144, 202, 249,0.11)",borderRadius:"15px",height:"50px",padding:"15px",margin:"5px"}}> 
  
                         <div style={{background:"transparent",border:"0px solid rgba(144, 202, 249,1)",
             
              transition: 'transform 2s ease, opacity 2s ease',display:"flex",justifyContent:"space-between"
            }}><div  style={{marginTop:"-5px"}}><h5>{"Allow Partial Marks For This Option?"} </h5></div>
            <Toggle state={isAllowPartialMarks=="false"?false:isAllowPartialMarks=="true"?true:false} 
            toggleState={(state)=>{setIsAllowPartialMarks(JSON.stringify(state)); ;setIsAllowPartialMarksBack(currentOption?.ID,JSON.stringify(state)) ;;}} />
      </div> 
      
      
      
      </div>
      {isAllowPartialMarks=="true"?<div style={{background:"#ffffff",margin:"5px",display:"grid", gridTemplateColumns: "40% 60%" ,borderRadius:"15px",marginTop:"10px",paddingTop:"10px",paddingBottom:"10px",}}>  
                          <div style={{fontSize:"16px",fontWeight:"bold",paddingLeft:"10",padding:"8px",paddingTop:"15px"}}>
                           Partial   Marks  (+)</div>         
                     <div style={{margin: '5px' ,paddingLeft:"20px",width:"150px", display:"grid", gridTemplateColumns: "50% 30% 0%" ,alignItems:"center"  }}>
       <Minus  onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave}  onClick={()=>{setPartialMarks(parseFloat(partialMarks)>0?parseFloat(partialMarks)-0.5:0)
       ; setPartialMarksBack(currentOption?.ID,parseFloat(partialMarks)>0?parseFloat(partialMarks)-0.5:0)
        }} style={{border:"3px solid rgba(144, 202, 249,1) ",width:"25px",height:"25px",borderRadius:"50%",marginLeft:"0px",
              alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer"}} color="rgba(144, 202, 249,1)" size={13}/>
          <input onMouseEnter={handleMouseEnter} 
           onMouseLeave={handleMouseLeave}  value={partialMarks?parseFloat(partialMarks):currentOption?.partialMarks?parseFloat(currentOption?.partialMarks):0} type="number"
                onChange={(e)=>{
                  ;
                  ;setPartialMarks(parseFloat(e.target.value)<100?parseFloat(e.target.value):0);
                setPartialMarksBack(currentOption?.ID,parseFloat(e.target.value)<100?parseFloat(e.target.value):0)}}
                style={{border:"0px dashed #555555  ",borderRadius:"10px",outline:0,width:"50px",marginLeft:"-5px",
                  padding:"0px",fontSize:"20px",color:"#555555 ",background:"#fff",fontWeight:"bolder",marginTop:"0px",}}
            />  <Plus onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}  
            onClick={()=>{setPartialMarks(parseFloat(partialMarks)<100?parseFloat(partialMarks)+0.5:0)
            setPartialMarksBack(currentOption?.ID,parseFloat(partialMarks)<100?parseFloat(partialMarks)+0.5:0)
              ; 
            
            }}  style={{border:"3px solid rgba(144, 202, 249,1) ",width:"25px",height:"25px",borderRadius:"50%",marginRight:"0px",
              alignContent:"center",textAlign:"center",marginLeft:"-5px",padding:"5px",cursor:"pointer"}}  color="rgba(144, 202, 249,1)" size={13}/>
              
              
              
              </div> 
              
              </div>:""}
              
              
              </div>:""}
              
      {displayType=="textbox"?<div style={{background:"rgba(144, 202, 249,0.11)",borderRadius:"15px",paddingBottom:"10px",marginTop:"10px",padding:"10px",display:"flex",justifyContent:"space-between"}}>
                                                     <div style={{fontSize:"17px",fontWeight:"bold",padding:"5px",marginTop:"25px",
                                               paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                                               TextBox Alignment</div> 
                              
                                           <div className="" style={{borderRadius:"0px",paddingBottom:"0px",marginTop:"10px",
                                            height:"80px"}}> 
                                     <div >  
                                         <div style={{}}> 
                                          <div class=""style={{
                                               
                                                transition: 'transform 3s ease, opacity 3s ease',
                                              borderRadius:"25px",padding:"5px"}} >
                                                                        
                                                                        <div style={{display:"flex",justifyContent:"space-between",gap:"10px"}}>
                                                                            <label onMouseEnter={
                                                                           ()=>handleMouseEnter("#fff","#333","")}
                                                            onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}}>
                                                                           <div style={{display:"flex",flexDirection: "column",width:"70px"}} >
                                                                            <div style={{display:"flex",justifyContent:"center"}}>
                                                                           <TabletSmartphone onMouseEnter={handleMouseEnter}
                                                                                                   onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                                                    
                                                                                                   }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                                                   </div>
                                                                                                  <div style={{position:"relative",fontSize:"14px",textAlign:"center"}}>Left</div>
                                                                                                   </div>  
                                                              <input type="radio" title="Set As Years"   checked={isOptionBoxAlign=="left"?"yes":""}
                                                 className="input-textbox"  value={"left"}  name="OptionBoxAlign1"  
                                                 onClick={e=>{setOptionBoxAlign("left");updateOptionBoxAlign(currentOption?.ID,"left");}}/>
                                                      <span class={"boxCardBorder-two"}></span> </label>  
                                                           <label onMouseEnter={
                                                                           ()=>handleMouseEnter("#fff","#333","")}
                                                            onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}}>
                                                                           <div style={{display:"flex",flexDirection: "column",width:"70px"}} >
                                                                            <div style={{display:"flex",justifyContent:"center"}}>
                                                                           <TabletSmartphone onMouseEnter={handleMouseEnter}
                                                                                                   onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                                                    
                                                                                                   }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                                                   </div>
                                                                                                  <div style={{position:"relative",fontSize:"14px",textAlign:"center"}}>Right</div>
                                                                                                   </div>  
                                                              <input type="radio" title="Set As Years"   checked={isOptionBoxAlign=="right"?"yes":""}
                                                 className="input-textbox"  value={"right"}  name="OptionBoxAlign1"  
                                                 onClick={e=>{setOptionBoxAlign("right");updateOptionBoxAlign(currentOption?.ID,"right");}}/>
                                                      <span class={"boxCardBorder-two"}></span> </label>  
                                                      
                                                      </div>  </div></div> </div>
                                                      
                                                                                  </div>
                              
                                               </div>:""}
    
{displayType=="dropdown"||questionType=="Drag Matching"?
<div>
  {questionType=="MCQ"?
  <div style={{display:"flex",justifyContent:"space-around"}} >
                                                  <div style={{marginTop:"0px"}}><h5>{"Reset All Toggle Status"} </h5></div>
                                                    <div style={{background:"transparent",border:"0px solid rgba(144, 202, 249,1)",
             
              transition: 'transform 2s ease, opacity 2s ease',display:"flex",justifyContent:"space-around"
            }}>
<div style={{paddingTop:"10px",position:"relative"}}> <label onMouseEnter={
                                                   ()=>handleMouseEnter("#fff","#333","")}
                                    onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                  <div  >
                                                 
                                                   {<ToggleLeft onMouseEnter={handleMouseEnter}
                                                                           onMouseLeave={handleMouseLeave}  onClick={()=>{ ;}} style={{position:"relative"}}   color="#555" size={22}/>}
                                                                           
                                                   </div> 
                                    <input type="checkbox" title="Color Theme"   checked={choiceType=="radio"?"yes":""}
                         className="input-textbox"  value={choiceType}  name="choiceType1"  
                         onClick={e=>{setTimeout(()=>{ updateChoiceCorrectAll(false)},0)}}/>
                              <span class={"boxCardBorder-two"}></span> </label></div></div></div>:""}
       
                                              
                       {loadStatus&&flattenedData?flattenedData.map((item, index) => 
        (<div  index={index} key={item.id} 
          ><div
          className="drop-zone"
          onDragOver={(e) => {setHoveredDropZone(index);
            handleDragOver(e, index)
          }}
          onDrop={(e) => handleDrop(e, index)}
        
          style={{
            height: hoveredDropZone === index ?'60px':"0px",position:hoveredDropZone === index ?'relative':"",left:"10px",right:"0px",
            backgroundColor: hoveredDropZone === index ? 'rgba(149, 143, 218,0.2) ' : 'transparent', // Change color on hover
            border: hoveredDropZone === index ? '2px dashed rgba(149, 143, 218,1) ' : 'transparent', // Change color on hover
            transition: 'background-color  0.3s ease',width:"95%",
            borderRadius: '10px',marginBottom:hoveredDropZone === index ?"20px":"0px"
           
          }}
        ></div>
            <div
             draggable 
                    
onDragOver={(e) => { if(selectedItemIndex!==index){setHoveredDropZone(index);
    handleDragOver(e, index)}
  }}
  onDrop={(e) => {if(selectedItemIndex!==index){handleDrop(e, index);setSelectedItemIndex(null);}}}

             onDragStart={(e) =>{ handleDragStart(e, index);
              setDraggedIndex(item.id);setSelectedItemIndex(index);
             }}
             style={{
              cursor: 'move',
             
              
            }}  className={draggedIndex == item.id?"posFixed":"posRelative"  }
          
              onDragEnd={handleDragEnd}
            >
              {<OptionValuesAddMore
              questionType={currentOption?.questionType}
              choiceType={choiceType}
              choiceCorrect={item?.choiceCorrect}
              choiceBoxAlign={item?.choiceBoxAlign}
              setChoiceCorrect={(id,state)=>{updateChoiceCorrect(id,state)}}
              updateOptionBoxAlign={updateOptionBoxAlign}
              allowPartialMarksStatus={item?.allowPartialMarks}
              updateAllowPartialMarks={updateAllowPartialMarks}
              partialMarksChoiceValue={item?.partialMarksChoice}
              setPartialMarksChoiceBack={updatePartialMarksChoice}
              index={index} key={item.id} 
        optionImageStatus={item?.optionImage} draggableImageStatus={item?.draggableImage}
        changeOptionImageStatus={updateOptionImageStatus} changeDraggableImageStatus={updateDraggableImageStatus}
        optionImageKey={item?.optionImageKey} draggableImageKey={item?.draggableImageKey}
        changeOptionImage={updateOptionImage} changeDraggableImage={updateDraggableImage}
         optionTitle={item?.optionTitle} 
         optionTitle2={item?.optionTitle2}  id={item.id} 
           changeItemOptionTitle={updateItemOptionTitle }
             changeItemOptionTitle2={updateItemOptionTitle2 } onRemove={removeItem} />}
          </div>
          
          </div>)):"" } 
                <div style={{display:"flex",justifyContent:"center"}}>
            <div onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave} onClick={()=>{setItemArr([...itemArr,newChoice]) ;  setDropdownValues([...dropdownValues,newChoice]); }}style={{width:"40px",height:"40px",cursor:"pointer",
                  borderRadius:"50%",margin:"5px",marginBottom:"20px",
                background:"#958FDA"}} > <Plus  style={{margin:"9px"}}  color="#ffffff" size={22}/></div></div>
                
 <div style={{background:"rgba(144, 202, 249,0.11)",borderRadius:"15px",paddingBottom:"10px",marginTop:"10px",padding:"10px",display:"flex",justifyContent:"space-between"}}>
                                                     <div style={{fontSize:"17px",fontWeight:"bold",padding:"5px",marginTop:"25px",
                                               paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                                               ChoiceBox Alignment</div> 
                              
                                           <div className="" style={{borderRadius:"0px",paddingBottom:"0px",marginTop:"10px",
                                            height:"80px"}}> 
                                     <div >  
                                         <div style={{}}> 
                                          <div class=""style={{
                                               
                                                transition: 'transform 3s ease, opacity 3s ease',
                                              borderRadius:"25px",padding:"5px"}} >
                                                                        
                                                             
                                                      
   {questionType=="Drag Matching"?   <div> <div style={{display:"flex",justifyContent:"space-between",gap:"10px"}}>
                                                                           
                                                           <label onMouseEnter={
                                                                           ()=>handleMouseEnter("#fff","#333","")}
                                                            onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}}>
                                                                           <div style={{display:"flex",flexDirection: "column",width:"70px"}} >
                                                                            <div style={{display:"flex",justifyContent:"center"}}>
                                                                           <ArrowBigRightDash onMouseEnter={handleMouseEnter}
                                                                                                   onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                                                    
                                                                                                   }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                                                   </div>
                                                                                                  <div style={{position:"relative",fontSize:"14px",textAlign:"center"}}>Center</div>
                                                                                                   </div>  
                                                              <input type="radio" title="Set As Years"   checked={isOptionBoxAlign=="Center"?"yes":""}
                                                 className="input-textbox"  value={"Center"}  name="OptionBoxAlign1"  
                                                 onClick={e=>{setOptionBoxAlign("Center");updateOptionBoxAlign(currentOption?.ID,"Center");}}/>
                                                      <span class={"boxCardBorder-two"}></span> </label>  
                                                      
                                                                            <label onMouseEnter={
                                                                           ()=>handleMouseEnter("#fff","#333","")}
                                                            onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}}>
                                                                           <div style={{display:"flex",flexDirection: "column",width:"70px"}} >
                                                                            <div style={{display:"flex",justifyContent:"center"}}>
                                                                           <ArrowBigUpDash onMouseEnter={handleMouseEnter}
                                                                                                   onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                                                    
                                                                                                   }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                                                   </div>
                                                                                                  <div style={{position:"relative",fontSize:"14px",textAlign:"center"}}>Up</div>
                                                                                                   </div>  
                                                              <input type="radio" title="Set As Years"   checked={isOptionBoxAlign=="Up"?"yes":""}
                                                 className="input-textbox"  value={"Up"}  name="OptionBoxAlign1"  
                                                 onClick={e=>{setOptionBoxAlign("Up");updateOptionBoxAlign(currentOption?.ID,"Up");}}/>
                                                      <span class={"boxCardBorder-two"}></span> </label>  
                                                           <label onMouseEnter={
                                                                           ()=>handleMouseEnter("#fff","#333","")}
                                                            onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}}>
                                                                           <div style={{display:"flex",flexDirection: "column",width:"70px"}} >
                                                                            <div style={{display:"flex",justifyContent:"center"}}>
                                                                           <ArrowBigDownDash onMouseEnter={handleMouseEnter}
                                                                                                   onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                                                    
                                                                                                   }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                                                   </div>
                                                                                                  <div style={{position:"relative",fontSize:"14px",textAlign:"center"}}>Down</div>
                                                                                                   </div>  
                                                              <input type="radio" title="Set As Years"   checked={isOptionBoxAlign=="Down"?"yes":""}
                                                 className="input-textbox"  value={"Down"}  name="OptionBoxAlign1"  
                                                 onClick={e=>{setOptionBoxAlign("Down");updateOptionBoxAlign(currentOption?.ID,"Down");}}/>
                                                      <span class={"boxCardBorder-two"}></span> </label>  
                                                      
                                                      </div> 
                                                    </div>
                                                      
                                                      :        <div style={{display:"flex",justifyContent:"space-between",gap:"10px"}}>
                                                                            <label onMouseEnter={
                                                                           ()=>handleMouseEnter("#fff","#333","")}
                                                            onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}}>
                                                                           <div style={{display:"flex",flexDirection: "column",width:"70px"}} >
                                                                            <div style={{display:"flex",justifyContent:"center"}}>
                                                                           <TabletSmartphone onMouseEnter={handleMouseEnter}
                                                                                                   onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                                                    
                                                                                                   }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                                                   </div>
                                                                                                  <div style={{position:"relative",fontSize:"14px",textAlign:"center"}}>Left</div>
                                                                                                   </div>  
                                                              <input type="radio" title="Set As Years"   checked={isOptionBoxAlign=="left"?"yes":""}
                                                 className="input-textbox"  value={"left"}  name="OptionBoxAlign1"  
                                                 onClick={e=>{setOptionBoxAlign("left");updateOptionBoxAlign(currentOption?.ID,"left");}}/>
                                                      <span class={"boxCardBorder-two"}></span> </label>  
                                                           <label onMouseEnter={
                                                                           ()=>handleMouseEnter("#fff","#333","")}
                                                            onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}}>
                                                                           <div style={{display:"flex",flexDirection: "column",width:"70px"}} >
                                                                            <div style={{display:"flex",justifyContent:"center"}}>
                                                                           <TabletSmartphone onMouseEnter={handleMouseEnter}
                                                                                                   onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                                                    
                                                                                                   }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                                                   </div>
                                                                                                  <div style={{position:"relative",fontSize:"14px",textAlign:"center"}}>Right</div>
                                                                                                   </div>  
                                                              <input type="radio" title="Set As Years"   checked={isOptionBoxAlign=="right"?"yes":""}
                                                 className="input-textbox"  value={"right"}  name="OptionBoxAlign1"  
                                                 onClick={e=>{setOptionBoxAlign("right");updateOptionBoxAlign(currentOption?.ID,"right");}}/>
                                                      <span class={"boxCardBorder-two"}></span> </label>  
                                                      
                                                      </div>   
                                                      }
                                                      
                                                      
                                                      
                                                        </div></div> </div>
                                                      
                                                                                  </div>
                              
                                               </div>
                
                </div>:"" }

                
 </div>
 

 </div>

</div>





</div>

<div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"0px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{closeOptionPopUp(false)}}   className=" CoursesPreviewTopBtn"  type="submit"style={{background:"#222222",color:"#fff",}}
 > Cancel </button>
<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{console.log(dropdownValues)
    console.log({
      ID: currentOption?.ID,
      questionType: "",
      optionText: optionText,
    optionImg: optionImg,
    partialMarks: partialMarks,
    displayType: displayType,
    dropdownValues: JSON.stringify(dropdownValues),
    isAllowPartialMarks: isAllowPartialMarks,
    isCorrect: isCorrect,
    isSingleRange:isSingleRange,
          optionSingle:optionSingle,
          optionRange:JSON.stringify(optionRange),
          dragOrder:dragOrder,
    textBoxValue: textBoxValue,optionBoxAlign:isOptionBoxAlign
})
    
    
    sendBackObject({
      ID: currentOption?.ID,
      questionType: "",
      optionText: optionText,
    optionImg: optionImg,
    partialMarks: partialMarks,
    displayType: displayType,
    dropdownValues: JSON.stringify(dropdownValues),
    isAllowPartialMarks: isAllowPartialMarks,
    isCorrect: isCorrect,
    isSingleRange:isSingleRange,
          optionSingle:optionSingle,
          optionRange:JSON.stringify(optionRange),
          dragOrder:dragOrder,
    textBoxValue: textBoxValue,optionBoxAlign:isOptionBoxAlign
});}}  style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":objectNew?"Create Option":"Save Changes"} </button>
</div> 
</div>

     </div>

       <div>
     </div>

    {openUploaderPopUp?<UploaderAllCM 
    
      fileTypeObject={[currentFileType]}
    // fileTypeObject={[
      // {title:"All",value:"all"},
      // {title:"Images",value:"image"},
      // {title:"Videos",value:"video"},
                    // {title:"Pdfs",value:"pdf"},{title:"Audio",value:"audio"},{title:"Zip",value:"zip"},{title:"PPT",value:"ppt"},
                    // {title:"Docs",value:"docs"},{title:"CSV",value:"csv"}
                    // ]}
                    selectedFileObject={currentFileObject} currentFileObject={currentFileObject} setCurrentFileObject={(v)=>{setCurrentFileObject(v);setItemImg(currentOption?.ID,v?.file_s3_key,currentOption?.ID);setOptionImg(v?.file_s3_key)}} setCloseUploaderPopUp={()=>{setOpenUploaderPopUp(false)}} />:""}
     
     </>


}
export default CreateQueOptionPopUp;